/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ComunicazioneEmailForm { 
    /**
     * Comune mittente e di perimetro. Per un OP_COMUNE che ne gestisce piu\' di uno e\' obbligatorio, se ne gestisce uno solo e\' il default. Per un SUPERADMIN e\' opzionale: assente = mittente di piattaforma e nessun vincolo sui destinatari.
     */
    comune_id?: string;
    /**
     * Cittadini destinatari: almeno uno, al massimo 50 id distinti (i duplicati sono ridotti a uno).
     */
    user_ids: Array<string>;
    /**
     * Oggetto. Ammessi i segnaposto {{nome}} e {{cognome}}. Va a capo e caratteri di controllo sono sostituiti con uno spazio.
     */
    oggetto: string;
    /**
     * Corpo in HTML prodotto dall\'editor rich-text. Viene sanitizzato dal server: restano solo paragrafi, a capo, grassetto, corsivo, sottolineato, elenchi e link http/https/mailto. Ammessi i segnaposto {{nome}} e {{cognome}}.
     */
    corpo_html: string;
}

